import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { MsalProvider } from '@azure/msal-react';
import { PublicClientApplication } from '@azure/msal-browser';
import { App, msalConfig } from './App';
import './styles.css';
import './evidence.css';
const identity = new PublicClientApplication(msalConfig);
createRoot(document.getElementById('root')!).render(<StrictMode><MsalProvider instance={identity}><App /></MsalProvider></StrictMode>);
